import React, { Component } from 'react';
import BaseLayout from './../../templates/base';
import ConceptEditForm from '../../elements/concepts/form';
import Loading from './../../elements/loading';
import ConceptsAdd from './../../elements/concepts/widget/concepts_add';

class ConceptEdit extends Component {
	render() {
		const { concepts, status } = this.props;
		return (
			concepts.isFetching || status.isFetching ? <Loading/>:<ConceptEditForm {...this.props}/>
		)
	}

	componentWillMount() {
		this.props.fetchConcept(this.props.match.params.id);
	}
}

export default BaseLayout(ConceptEdit, {
	title: `Editar Concepto`,
	subnav: {
		icon: 'fa-list-alt',
		name: 'Conceptos',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <ConceptsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/concepts/edit.jsx